<template>
  <work-order-form />
</template>

<script>
import WorkOrderForm from "../components/Form";

export default {
  name: "WorkOrder",
  props: ["id"],

  components: {
    WorkOrderForm
  }
};
</script>
